
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import '../../bootstrap';
import '../../plugins';
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import Multiselect from 'vue-multiselect';
import VueMoment from 'vue-moment';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
// import VueClockPicker from '@pencilpix/vue2-clock-picker';
// import Dayjs from 'vue-dayjs';

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css';
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
// import '@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css';

// import VueScrollTo  from 'vue-scrollto';

window.Vue = Vue;

const VueUploadComponent = require('vue-upload-component')

const phoneOrEmailRule = {
  getMessage(field, args) {
    return `The ${field} must be either a valid phone number`;
  },
  validate(value, args) {

    // Custom regex for a phone number
    const MOBILEREG = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;

    return MOBILEREG.test(value);
  }
};

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueSweetalert2)
Vue.use(VueMoment);
Vue.use(VeeValidate, {
    inject: true,
    fieldsBagName: "veeFields",
    errorBagName: "veeErrors"
});
// Vue.use(Dayjs)

// VeeValidate.Validator.extend('phone', phoneOrEmailRule);

// Vue.use(VueScrollTo, {
//      container: "body",
//      duration: 500,
//      easing: "ease",
//      offset: 0,
//      force: true,
//      cancelable: true,
//      onStart: false,
//      onDone: false,
//      onCancel: false,
//      x: false,
//      y: true
//  })
Vue.component('file-upload', VueUploadComponent)
Vue.component('multiselect', Multiselect)
// Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

Vue.component('show-form', require('./components/Form.vue').default);
Vue.component('show-notif', require('./components/Notif.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    data: {
        choosedData:{},
        isShowForm:true,
        isShowNotif:false,
    },
    methods: {// receives a place object via the autocomplete component

        getData(value){
            if(value.action=='form'){
                this.reset()
                this.isShowForm=true
            }else if(value.action=='notif'){
                this.reset()
                this.isShowNotif=true
            }
            this.choosedData = value.data
        },
        reset(){
            this.isShowForm=false
            this.isShowNotif=false
        }

    }
});
